export const settings = {
  projectId: 'max-towers',
  companyName: 'Max Towers',
  path: 'maxtowers',
  apiKey: 'AIzaSyBLZpitRybduRmzwJA-LMMayAMfllL9CJw',
  authDomain: 'max-towers.firebaseapp.com',
  databaseURL: 'https://max-towers.firebaseio.com',
  storageBucket: 'max-towers.appspot.com',
  messagingSenderId: '730117487387',
  appId: '1:730117487387:web:e78d1f3d89ec629b05b1be',
  dashboard_url: 'https://community.maxtowers.com',
  // dashboard_url: 'http://localhost:5000/max-towers/us-central1/api',
  bundleId: 'com.vizmo.maxtowers'
};
